import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { MediaSwitch } from '../modules/media-switch.js'
import { gsap } from 'gsap'

import { OverlayInteractionListener } from '../utils/overlay-interaction-listener.js'

class VideoOverlay {
	constructor(element) {
		this.element = element
		this.elPlayer = this.element.querySelector('.video-overlay__player')
		this.elToggle = document.body.querySelector('.js-toggle-video-overlay')
		this.isVisible = false

		this.bndToggleClick = this.onToggleClick.bind(this)
		if (this.elToggle) {
			this.elToggle.addEventListener('click', this.bndToggleClick)
		}

		this.overlayInteractionListener = new OverlayInteractionListener({
			element: this.elPlayer,
			enabled: false,
			onKeyPress: this.hideOverlay.bind(this, false),
			onClickOutside: this.hideOverlay.bind(this, false),
		})
	}
	onToggleClick(ev) {
		ev.preventDefault()
		ev.stopPropagation()

		if (this.isVisible) {
			this.hideOverlay()
		} else {
			this.showOverlay()
		}
	}
	// The player component owns playback; the overlay only tells it when to start
	// and stop. Returns null until the component has mounted.
	getPlayer() {
		const elPlayer = this.element.querySelector('.js-bunny-player')
		return elPlayer ? ComponentsManager.getComponentByElement(elPlayer, 'bunny-player') : null
	}
	showOverlay() {
		gsap.set(this.element, { display: 'flex', opacity: 0 })
		gsap.to(this.element, { opacity: 1, duration: 0.2 })

		gsap.fromTo(this.elPlayer, { y: '20px', opacity: 0 }, { y: '0px', opacity: 1, duration: 0.4, delay: 0.1, ease: 'power3.out' })
		this.isVisible = true

		// Synchronous, so this still counts as the user gesture from the click
		// that opened the overlay and playback may start with sound.
		const player = this.getPlayer()
		if (player) {
			player.playVideo()
		}

		if (this.overlayInteractionListener) {
			this.overlayInteractionListener.enable()
		}
	}
	hideOverlay() {
		this.isVisible = false

		gsap.to(this.element, {
			opacity: 0,
			duration: 0.2,
			ease: 'power3.out',
			onComplete: () => {
				gsap.set(this.element, { display: 'none' })

				// reset the player so reopening the overlay starts from the top
				const playerComponent = this.getPlayer()
				if (playerComponent) {
					playerComponent.resetVideo()
				}
			},
		})

		// gsap.set(this.element, { autoAlpha: 0 })
		if (this.overlayInteractionListener) {
			this.overlayInteractionListener.disable()
		}
	}
	destroy() {
		if (this.elToggle) {
			this.elToggle.removeEventListener('click', this.bndToggleClick)
		}
		if (this.overlayInteractionListener) {
			this.overlayInteractionListener.destroy()
		}
	}
}

//
export default class extends Component {
	prepare() {
		this.videoOverlay = new VideoOverlay(this.element)
	}

	mount() {}

	unmount() {}
}
